module.exports = __webpack_public_path__ + "static/media/news_1.fd3e2696.png";